import { DropdownButton } from '@neo4j-ndl/react';
import { useActiveDatabase, useConnection } from '@nx/state';
import cx from 'classnames';
import { useRef, useState } from 'react';

import { DatabaseMenu } from './database-menu';
import { InfoItem } from './info-item';

export function DatabaseMenuButton() {
  const connection = useConnection();
  const activeDatabase = useActiveDatabase();

  const buttonRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isDisabled = !connection.status.isConnected;

  return (
    <>
      <DropdownButton
        aria-label="Toggle database menu"
        htmlAttributes={{ 'data-testid': 'database-menu-button' }}
        size="small"
        ref={buttonRef}
        isOpen={isMenuOpen}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        // '[&>.ndl-icon-svg]:hidden' hides chevron icon when button is disabled
        className={cx('border-none', { '[&>.ndl-icon-svg]:hidden': isDisabled })}
        isDisabled={isDisabled}
      >
        <InfoItem label="Database:" value={activeDatabase?.selectedName ?? '-'} />
      </DropdownButton>

      <DatabaseMenu isMenuOpen={isMenuOpen} anchorEl={buttonRef} onClose={() => setIsMenuOpen(false)} />
    </>
  );
}
